import React, {useState, useEffect} from "react";

const BlockedTalentWelcome = () => {
    const [shouldShow, setShouldShow] = useState(true);

    useEffect(() => {
        const preferences = TB.storedPreferences();
        if (!!preferences.hide_blocked_talent_welcome) {
            setShouldShow(false);
        }
    }, [])

    const handleDontShowAgain = () => {
        TB.persistStoredPreferences({hide_blocked_talent_welcome: true});
        setShouldShow(false);
    }

    if (!shouldShow) {
        return null;
    }

    return (
        <div className="bg-white p-8 md:p-16">
            <h1 className="text-3xl font-bold">
                Blocked Talent Pool
            </h1>

            <div className="my-12">
                <img src="/images/heads.png" className="m-auto grayscale brightness-90 contrast-110 sepia-[.15] hue-rotate-[-10deg] saturate-[1.2]" alt=""/>
            </div>

            <div className="flex flex-col gap-7">
                <p className="text-sm">
                    The Blocked Talent pool allows you to prevent specific talent from seeing your
                    organization's job postings and ensures they won't appear in your talent searches.
                    This feature helps you manage your talent network more effectively.
                </p>

                <div className="flex flex-col gap-4">
                    <h3 className="text-xl text-wrippleDangerDark">
                        How It Works
                    </h3>
                    <p className="text-sm">
                        When you add talent to this pool, they will be automatically excluded from:
                    </p>
                    <ul className="text-sm list-disc pl-6">
                        <li>Viewing any of your organization's job postings and/or projects</li>
                        <li>Appearing in Browse Talent search results</li>
                        <li>Appearing in talent searches within job postings and/or projects</li>
                    </ul>
                </div>

                <div className="flex flex-col gap-4">
                    <h3 className="text-xl text-wrippleDangerDark">
                        Important Notes
                    </h3>
                    <ul className="text-sm list-disc pl-6">
                        <li>Blocked talent will <b><i>NOT</i></b> be notified that they have been blocked</li>
                        <li>You can remove talent from this pool at any time to restore their visibility</li>
                        <li>This blocking is organization-wide and applies to all users in your company</li>
                        <li>Talent already hired or in active contracts will not be affected by blocking</li>
                    </ul>
                </div>

                <div className="flex flex-col gap-4">
                    <h3 className="text-xl text-wrippleDangerDark">
                        Adding Talent to Blocked Pool
                    </h3>
                    <p className="text-sm">
                        You can add talent to this pool by using the "Add Talent"
                        button to search and select talent to block. Once added, the blocking takes effect
                        immediately.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BlockedTalentWelcome;